import React, { useEffect } from 'react';
import { SalesRolePopup } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleDescriptionField/SalesRoleField/SalesRolePopup/SalesRolePopup';

export const SalesRoleField = ({
  fields,
  data,
  setValue,
  readonly = false,
  roleClickValue,
  watch,
  compact = false,
}) => {
  useEffect(() => {
    if (data.pf_cta) {
      setValue('pf_cta', data.pf_cta);
    }
    if (data.pf_icp) {
      setValue('pf_icp', data.pf_icp);
    }
  }, []);

  const addSalesRole = (submitData) => {
    setValue('pf_icp', submitData.pf_icp);
    setValue('pf_cta', submitData.pf_cta);
  };

  return (
    <div className={'flex flex-col w-full gap-2.5'}>
      {!readonly && (
        <div>
          <SalesRolePopup
            data={data}
            watch={watch}
            addSalesRole={addSalesRole}
            roleClickValue={roleClickValue}
          />
        </div>
      )}
    </div>
  );
};
